import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function UserPermission() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const adminmob = queryParams.get('adminmob');
  const branchId = queryParams.get('branchId');
  const empmobile = queryParams.get('empmobile');
   const navigate = useNavigate();
   const udiseNumber= localStorage.getItem("udiseNumber")
  const [selectedValue, setSelectedValue] = useState('');
   const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  
        useEffect(() => {
                   const storedLanguage = localStorage.getItem('language') || 'English';
                   setLanguage(storedLanguage);
                 }, []);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleSave = () => {
    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/`;
    const ref = `${firebaseUrl}/${udiseNumber}/AttData/${empmobile}.json`;
    console.log("firebaseUrl",firebaseUrl);
    console.log("ref",ref);

    
    fetch(ref, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data) {
        data.Employeetype = selectedValue;
        return fetch(ref, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
      } else {
        return fetch(ref, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ Employeetype: selectedValue }),
        });
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Data saved successfully:', data);
    })
    .catch(error => {
      console.error('Error:', error);
    });
  };
  
  useEffect(() => {
    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/`;
    const ref = `${firebaseUrl}/${udiseNumber}/AttData/${empmobile}.json`;
    
    fetch(ref, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data) {
        setSelectedValue(data.Employeetype);
      }
    })
    .catch(error => {
      console.error('Error fetching Teacher details:', error);
    });
  }, [adminmob, branchId, empmobile]);

  const handleClose = () => {
    navigate(-1); // Change '/profile' to the actual path of your profile page
};

  return (
      <div className='main-content-of-page'>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        backgroundColor:'rgba(150, 201, 238, 0.60)',
        height:'500px',
        width:'600px',
        margin:'auto',
        marginTop:'140px',
        border:'1px solid black'
      }}> 
      <button style={{ 
                            backgroundColor: '#dc3545', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: '5px', 
                            cursor: 'pointer', 
                            fontSize: '20px', 
                            marginLeft: '520px',
                            marginBottom:'10px',
                            fontWeight:'bold',
                           // Add some space between buttons
                        }} onClick={handleClose}> 
                           X
                        </button>
        <div style={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '25px',
          marginBottom: '20px',
          border:'2px solid black',
          width:'300px',
          borderRadius:'8px',
          backgroundColor:'#03365e',
         
        }}>
          <label style={{ color: 'white' }}>{language === "English" ? "User   Permission " : "वापरकर्ता परवानगी"}</label>
        </div>

        <div style={{
          fontWeight: 'bold',
          fontSize: '20px',
          marginBottom: '10px',
          marginTop:'20px',
          marginRight:'200px',

        }}>
          <label style={{ color: 'black' }}>{language === "English" ? "Select Any One : " : "कोणतीही एक निवडा:"}</label>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop:'15px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '10px',
          }}>
            <input
              type="radio"
              id="option1"
              name="Admin"
              value="Admin"
              checked={selectedValue === 'Admin'}
              onChange={handleRadioChange}
              style={{
                marginRight: '27px',
              }}
            />
            <label htmlFor="option1" style={{ color: 'black',fontWeight:'bold' }}>Admin</label>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '10px',
            marginTop:'10px'
          }}>
            <input
              type="radio"
              id="option2"
              name="Manager"
              value="Manager"
              checked={selectedValue === 'Manager'}
              onChange={handleRadioChange}
              style={{
                marginLeft: '20px',
              }}
            />
            <label htmlFor="option2" style={{ color: 'black',fontWeight:'bold',marginLeft:'30px' }}>Manager</label>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '20px',
            marginTop:'10px'
          }}>
            <input
              type="radio"
              id="option3"
              name="Teacher"
              value="Teacher"
              checked={selectedValue === 'Teacher'}
              onChange={handleRadioChange}
              style={{
                marginLeft: '0px',
              }}
            />
            <label htmlFor="option3" style={{ color: 'black',fontWeight:'bold',marginLeft:'25px' }}>Teacher</label>
          </div>

          <button onClick={handleSave} style={{
            padding: '10px 20px',
            backgroundColor: '#03365e',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s',
            marginTop:'70px',
            fontWeight:'bold',
          }}>
            Save
          </button>
          
        </div>
      </div>
      </div>

  );
}
export default UserPermission;